import { createReducer } from 'typesafe-actions';
import { AlertAction } from '@store/actions';
import { Alert, IParentModal } from '@types';
import { fetchAlertAsync, closeAlertAction } from '@store/actions/alerts.actions';

export interface AlertState {
    notification: Alert;
    parent: IParentModal | undefined;
    result: 'closed' | 'opened' | 'init' | string;
    selctedDisclosureUser: string;
}

export const notification: AlertState = {
    notification: {} as Alert,
    parent: undefined,
    result: 'init',
    selctedDisclosureUser: ''
};

export const alertReducer = createReducer<AlertState, AlertAction>(notification)
    .handleAction(fetchAlertAsync.success, (state, action) => {
        return {
            ...state,
            notification: action.payload
        };
    })
    .handleAction(closeAlertAction, (state, action) => {
        const notifications = [...state.notification.notifications];
        const filteredNotification = notifications.filter(ele => ele.notificationId !== action.payload.notificationId);

        let newNotifications = { ...state.notification };
        newNotifications = {
            notifications: [...filteredNotification]
        };

        const updatedState = {
            ...state,
            notification: {
                ...state.notification,
                ...newNotifications
            }
        };
        return updatedState;
    });
